import { PropsWithChildren } from 'react';
import { Tab, Nav } from 'react-bootstrap';
import styled from 'styled-components';
import { colors } from '../common/constants';
import { IconCalendarOutline } from '../icons/IconCalendar';
import { IconClockOutline } from '../icons/IconClock';
import { IconNightOutline } from '../icons/IconNight';
import { PriceOptions } from '../types/bookingFormTypes';

export const StyledPriceTabs = styled.div`
  .nav-pills {
    justify-content: center;
    gap: 4px;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .nav-link {
    padding-left: 8px;
    padding-right: 8px;
    border-radius: 32px;

    &:hover:not(.active) {
      color: ${colors.primary};
      background-color: ${colors.backgroundHover};
    }
  }
`;

interface IProps {
  defaultActiveKey: string;
  onSelect: (key?: any) => void;
}

export const PriceTabs = ({ defaultActiveKey, onSelect, children }: PropsWithChildren<IProps>) => {
  return (
    <StyledPriceTabs>
      <Tab.Container defaultActiveKey={defaultActiveKey} onSelect={onSelect}>
        <Nav justify variant="pills">
          <Nav.Item>
            <Nav.Link eventKey={PriceOptions.Hour}>
              <IconClockOutline /> Theo giờ
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey={PriceOptions.Night}>
              <IconNightOutline /> Qua đêm
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey={PriceOptions.Day}>
              <IconCalendarOutline /> Theo ngày
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <Tab.Content>{children}</Tab.Content>
      </Tab.Container>
    </StyledPriceTabs>
  );
};
